import { jwtDecode } from "jwt-decode"

export interface JWTPayload {
  sub?: string
  email?: string
  role_id?: string
  role_name?: string
  permissions?: Record<string, { view?: boolean; manage?: boolean }>
  iat?: number
  exp?: number
}

export function decodeJWT(token: string | null | undefined): JWTPayload | null {
  if (!token) return null
  try {
    return jwtDecode<JWTPayload>(token)
  } catch {
    return null
  }
}
